import { useEffect, useRef, useState } from "react";
import Button from "../../components/button/Button";
import { PhoneContact } from "../../model/PhoneContact";
import { ContactInformationEditModal } from "./ContactInformationEditModal";
import { ContactInformationRef } from "./ContactInformationRef";
import companiesQuery from "../../firestore/Companies.query";
import { auth } from "../../firebase";
import { Spiner } from "../../components/spinner/Spiner";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";

export const ContactInformationSettingPage = () => {

  const dispatch = useDispatch();

  const isDisabled = useRef(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [phoneContact, setPhoneContact] = useState<PhoneContact>();

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  useEffect(() => {
    const f = async () =>{
      setIsLoad(true);
      // 問い合わせ先情報取得
      const phoneContact = await companiesQuery.getPhoneContact(currentUser?.tenantId!);
      setPhoneContact(phoneContact);
      setIsLoad(false);
    };
    f();
  },[currentUser?.tenantId, isOpen]);

  const onSubmit = async (data: PhoneContact) => {
    setIsLoad(true);
    if(!isDisabled.current){
      try{
        isDisabled.current = true;
        if(data.id !== undefined && data.id !== ''){
          data.updateAt = new Date();
          await companiesQuery.updatePhoneContact(currentUser?.tenantId!, data);
        } else {
          data.createAt = new Date();
          await companiesQuery.addPhoneContact(currentUser?.tenantId!, data);
        }
        dispatch(alertOpen(AlertValue("問い合わせ先を保存しました", "success")));
        toggle();
        isDisabled.current = false;
      } catch (err: any) {
        let errorMessage = err.code;
        console.error(err);
        if (errorMessage === "ERR_NETWORK") {
          dispatch(alertOpen(AlertValue("ネットワークに接続できません。", "danger")));
        } else {
          dispatch(alertOpen(AlertValue("保存に失敗しました", "danger")));
        }
        isDisabled.current = false;
      }
      setIsLoad(false);
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="h-full">
      <div className="flex p-6 items-center">
        <div className="flex-auto">
          <h2 className="text-xl font-semibold text-gray-900">
            問い合わせ先設定
          </h2>
        </div>
      </div>
      {isLoad ? (<Spiner/>)
      : (
        <div className={"flex flex-col space-y-6"}>
          <ContactInformationRef phoneContact={phoneContact}/>
          <div className={"px-6 flex justify-end"}>
            <Button
              size={'sm'}
              children={'編集'}
              onClick={toggle}
            />
          </div>
          <ContactInformationEditModal
            children={undefined}
            open={isOpen}
            toggle={toggle}
            closeOnClickOutside={false}
            phoneConact={phoneContact}
            onSubmit={onSubmit}
          />
        </div>
        )}
    </div>
  );
};